import { flatten } from "lodash";
import combineFaultData from "../utils/combineFaultData";
import AddInIds from "@/constants/AddInIds";
import { useAddinData } from "@/hooks/addins/useAddinData";
import { useAddressesByDeviceStatusInfo } from "@/hooks/addresses/useAddresses";
import { useDevicesBySearch } from "@/hooks/devices/useDevicesBySearch";
import { useDiagnosticsByIds } from "@/hooks/diagnostic/useDiagnosticsByIds";
import { useLatestFaultData } from "@/hooks/faultData/useLatestFaultData";
import { useStatusInfosByIds } from "@/hooks/statusInfos/useStatusInfosByIds";
import { useUsersBySearch } from "@/hooks/users/useUsersBySearch";
import { useZonesByIds } from "@/hooks/zone/useZonesByIds";
import { DiagnosticAddinData } from "@/pages/diagnostic-edit/models/DiagnosticAddinData";

export const useFaultMonitorData = (fromDate: Date, toDate: Date, isReady = true) => {
  const { data: deviceData, refetch } = useDevicesBySearch("", false);
  const deviceIds = deviceData?.map(device => device.id) ?? [];
  const { data: faultData } = useLatestFaultData(
    deviceIds,
    fromDate,
    toDate,
    undefined,
    undefined,
    true,
    isReady,
  );
  const { data: diagnosticData } = useDiagnosticsByIds([
    ...new Set(faultData?.map(fault => fault.diagnostic.id)),
  ]);
  const { data: addinData = [] } = useAddinData<DiagnosticAddinData>(AddInIds.diagnosticData);
  const { data: statusInfos = {} } = useStatusInfosByIds(deviceIds);

  const { data: users = [] } = useUsersBySearch("", true, false, false);

  const { data: addresses = {} } = useAddressesByDeviceStatusInfo(statusInfos, undefined, true);
  const zoneIds = flatten(Object.values(addresses).map(addr => addr.zones))
    .map(zone => (zone ? zone.id : "-1"))
    .filter(id => id != "-1");
  const { data: zones = {} } = useZonesByIds(zoneIds);

  const data = combineFaultData(
    diagnosticData ?? {},
    addinData ?? [],
    deviceData ?? [],
    faultData ?? [],
    statusInfos ?? {},
    users ?? [],
    addresses,
    zones ?? {},
  );

  return {
    data: data.filter(d => !(d.deviceId === "" || !d.deviceId || !d.diagnosticName)),
    refetch,
  };
};
